/**
 * Player Number Validation for YMQ Bundles
 * 
 * This script:
 * 1. Restricts player numbers to 3 digits (0-999)
 * 2. Displays validation rules to users
 * 3. Provides real-time feedback
 * 
 * How to implement:
 * 1. Go to Shopify Admin > Online Store > Themes
 * 2. Click "Actions" on your current theme and select "Edit code"
 * 3. Under "Assets", create a new JavaScript file (e.g., "player-number-validation.js")
 * 4. Paste this code and save
 * 5. In theme.liquid, add: <script src="{{ 'player-number-validation.js' | asset_url }}" defer></script> before the closing </body> tag
 */

(function() {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize after a delay to ensure YMQ is loaded
    setTimeout(initPlayerNumberValidation, 1000);
    
    // Re-initialize when pages/content changes
    observePageChanges();
  });
  
  function initPlayerNumberValidation() {
    // Find all player number input fields
    const playerNumberFields = document.querySelectorAll('input[name="ymq[PLAYER NUMBER]"], input[placeholder*="PLAYER#"]');
    
    if (playerNumberFields.length === 0) {
      console.log("No player number fields found");
      return;
    }
    
    console.log(`Found ${playerNumberFields.length} player number fields`);
    
    playerNumberFields.forEach((field, index) => {
      // Only set up once per field (in case of reinitialization)
      if (field.hasAttribute('data-validation-initialized')) {
        return;
      }
      
      // Mark as initialized
      field.setAttribute('data-validation-initialized', 'true');
      
      // Add validation rules message
      addValidationMessage(field);
      
      // Set maxlength attribute to 2
      field.setAttribute('maxlength', '2');
      
      // Add input restrictions
      field.addEventListener('input', function(e) {
        // Remove any non-numeric characters
        let value = this.value.replace(/[^0-9]/g, '');
        
        // Restrict to 2 digits
        if (value.length > 2) {
          value = value.slice(0, 2);
        }
        
        // Update the field value if it changed
        if (this.value !== value) {
          this.value = value;
        }
        
        // Update validation message
        updateValidationMessage(this);
      });
      
      // Validate on blur
      field.addEventListener('blur', function() {
        updateValidationMessage(this);
      });
      
      console.log(`Set up validation for player number field #${index + 1}`);
    });
  }
  
  function addValidationMessage(field) {
    // Create validation message element
    const messageEl = document.createElement('div');
    messageEl.className = 'player-number-rules';
    messageEl.innerHTML = '<small>Player number must be 1-2 digits (0-99)</small>';
    messageEl.style.fontSize = '0.85em';
    messageEl.style.color = '#666666';
    messageEl.style.marginTop = '5px';
    
    // Create validation status element
    const statusEl = document.createElement('div');
    statusEl.className = 'player-number-status';
    statusEl.style.fontSize = '0.85em';
    statusEl.style.marginTop = '3px';
    statusEl.style.display = 'none';
    
    // Insert after the input field
    const container = field.parentElement;
    container.insertBefore(messageEl, field.nextSibling);
    container.insertBefore(statusEl, messageEl.nextSibling);
  }
  
  function updateValidationMessage(field) {
    const container = field.parentElement;
    const statusEl = container.querySelector('.player-number-status');
    
    if (!statusEl) return;
    
    // Check if empty
    if (field.value === '') {
      statusEl.textContent = '';
      statusEl.style.display = 'none';
      return;
    }
    
    // Check if valid
    const isValid = /^[0-9]{1,2}$/.test(field.value);
    
    if (!isValid) {
      statusEl.textContent = '⚠ Please enter a valid player number (0-99)';
      statusEl.style.color = '#F44336';
      statusEl.style.display = 'block';
    } else {
      statusEl.textContent = '';
      statusEl.style.display = 'none';
    }
  }
  
  function observePageChanges() {
    // Watch for changes to the page content
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          // Check if any YMQ elements were added
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE && 
                (node.classList?.contains('ymq-options-box') || 
                 node.querySelector?.('.ymq-options-box'))) {
              console.log('YMQ content updated, reinitializing player number validation');
              setTimeout(initPlayerNumberValidation, 500);
              return;
            }
          }
        }
      }
    });
    
    // Start observing the body for changes
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also watch for YMQ events
    document.addEventListener('ymq:updated', function() {
      console.log('YMQ updated event detected');
      setTimeout(initPlayerNumberValidation, 500);
    });
    
    // Re-initialize when the cart is updated
    document.addEventListener('cart:updated', function() {
      console.log('Cart updated, reinitializing player number validation');
      setTimeout(initPlayerNumberValidation, 500);
    });
  }
})();